module.exports = __webpack_public_path__ + "static/media/shopelect.77e1417a.png";